import React, { useContext } from "react";
import { CommonDropdown } from "./CommonDropdown";
import { string, func } from "prop-types";
import { useTextDomainContext } from "@/app/providers";

export const EnergyReportTypeDropdown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const options = [
    {
      value: "monthly",
      label: gettext("Monthly"),
    },
    {
      value: "aggregated",
      label: gettext("Aggregated"),
    },
  ];
  const propsDefault = {
    componentLabel: gettext("Report"),
  };

  // Use props directly with fallback instead of state
  const componentLabel = props.componentLabel || propsDefault.componentLabel;

  return (
    <CommonDropdown
      options={options}
      componentLabel={componentLabel}
      showAll={false}
      defaultValue={props.defaultValue}
      onChange={props.onChange}
    />
  );
};

EnergyReportTypeDropdown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  onChange: func,
};
